import React, { useCallback } from 'react'
import { actionUrlConverter, isValidEmail } from '../../util/util'

export const SalesRepsV2 = React.memo(({appData:{storedata, affiliationdata} }) => {
	let schoolStoreReps = storedata?.schoolStoreReps?.sort((a, b) => parseInt(a.orderSeq) > parseInt(b.orderSeq) ? 1 : -1);

	// we show a mascot shop contact if the country is US and the customer class code is not a college
	const isMascotShopShown = affiliationdata?.country?.toUpperCase().trim() === "US" 
		&& !affiliationdata.customerClassCode?.toUpperCase().trim().includes("COLLEGE");

	if (isMascotShopShown) {
		schoolStoreReps = [
			...schoolStoreReps,
			{
				assignmentTypes: ["The Mascot Shop"],
				description: "For The Mascot Shop products, questions about your order or other service needs",
				salesRepName: "Mascot Shop Customer Service",
				phoneNumber: "1-855-200-1981",
				emailAddress: "cccmascotshop@jostens.com"
			}
		];
	}

	const descrLinkReplacer = useCallback((rep) => {
		const { linkText: link, description, assignmentTypes } = rep;
		if (!description) return description;

		const defaultLink = `<a href="${actionUrlConverter(link || "#")}">`
		const stackLinks = [defaultLink];
		
		const isYearbooksCustomerService = assignmentTypes?.[0] === "YEARBOOKS CUSTOMER SERVICE";

		// If Yearbook we put this link to render as the first
		if (isYearbooksCustomerService) {
			stackLinks.push(`<a href="${actionUrlConverter("/apps/jcom/router.mvc?code=YRBK")}">`)
		}
		
		// Replacing all links and if there are more linke we put default link instead
		const result = description.replaceAll("linkText", "a").replaceAll("<a>", () => stackLinks.pop() || defaultLink);

		return <p dangerouslySetInnerHTML={{__html: result}}></p>
	}, []);

	const contactsClass = `contacts items-${schoolStoreReps?.length}`

	return (
		<div className="rep-contact-v2">
			<div className="container overlay-contacts-container">	
				<div className="overlay-contacts-info">
				<h2>Contact information</h2>
					<div>
						<ul className={contactsClass}>
							{schoolStoreReps?.map((rep, key) => {	
								const title = rep.assignmentTypes.map((title) => title.toUpperCase()).join(', ')

								return (
									<li className='inner' key={`Sales Rep ${key}`}>
										<div>
											<h4 className='title'>
												{title}
											</h4>
											<div className='description'>
												{descrLinkReplacer(rep)}
											</div>
										</div>
										<div>	
											<h3 className='sales-rep-name'>{rep.salesRepName}</h3>
											<ul className='contact-details'>
												{rep.phoneNumber && <li><a href="#" className='text-decoration-none'>{rep.phoneNumber}</a></li>}

												{rep.emailAddress && isValidEmail(rep.emailAddress) && (
													<li>
														<a href={`mailto:${rep.emailAddress}`}>{rep.emailAddress}</a>
													</li>
												)}

												{rep.emailAddress && !isValidEmail(rep.emailAddress) && (
													<li>
														<a href={`https://${window.location.hostname}${rep.emailAddress}`}>
														{rep.emailAddress.includes('contact-us') ? 'Contact us' : rep.emailAddress}</a>
													</li>
												)}
											</ul>
										</div>
									</li>
								)}
							)}

						</ul>
					</div>
				</div>
			</div>
		</div>
	)
})
